import {storage} from "./localstorage";
import {AppComponent} from "../App";
import {statInfo, statPost} from "./stat";

export const getVideoURL = async (videoFileId, signal) => {
    const authData = storage("authData");

    const data = await fetch("https://mathem.org/data/video", {
        signal,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({videoFileId, userId: authData.id, token: authData.token})
    })

    return URL.createObjectURL(await data.blob())
}

export const postInvoice = async ({method, cost, ...request}) => {
    AppComponent.SetLoading(true);

    statPost(method === "success" && !cost ? "noCostInvoiceSuccess" : method);

    const res = await fetch(`https://mathem.org/invoice/${method}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(request)
    });

    AppComponent.SetLoading(false);

    return await res.json();
}

export const postPure = async ({method, ...request}) => {

    const res = await fetch(`https://mathem.org/${method}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(request)
    });


    return await res.json();
}

export const post = async ({method, ...data}, showLoading) => {
    const authData = storage("authData");

    statPost(method);

    showLoading && AppComponent.SetLoading(true);

    const res = await fetch(`https://mathem.org/data/${method}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({...data, token: authData.token})
    });

    showLoading && AppComponent.SetLoading(false);

    const response = await res.json();

    const {forbidden, locked, trialEndDays, invoiceEndDays, shouldTrial, shouldPay, shouldRenew, date, noticeDays, courses} = response.info || {};

    statInfo(response.info);

    if (typeof trialEndDays === "number") AppComponent.SetNotice({isTrial: true, days: trialEndDays, date, noticeDays});
    if (typeof invoiceEndDays === "number") AppComponent.SetNotice({isTrial: false, days: invoiceEndDays, date, noticeDays});


    AppComponent.Locked(locked);

    if (forbidden) {
        AppComponent.Forbidden();
        return response
    }

    if (shouldTrial) {
        AppComponent.ShouldTrial(courses);
        return response
    }

    if (shouldRenew) {
        AppComponent.ShouldRenew();
        return response
    }

    if (shouldPay) {
        AppComponent.ShouldPay();
        return response
    }

    AppComponent.Started();


    return response
}
